'use client';

/* eslint-disable jsx-a11y/control-has-associated-label */

import DOMPurify from 'isomorphic-dompurify';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { OocvTableFragmentFragmentDoc } from '@packages/gql/generated/shopping/OocvTableFragmentFragmentDoc';

/* GraphQL */ `
  fragment OocvTableFragment on OocvTable {
    headline
    rows {
      key
      value
    }
  }
`;

export type OocvTableProps = {
  oocvTableData: FragmentType<typeof OocvTableFragmentFragmentDoc>;
};

const tdStyle =
  'border-color-grey-light text-size-body2 text-normal border-collapse border-2 px-1.5 py-1 text-left align-top';

/**
 * `OocvTable` is a predefined custom table with one table head and n table rows.
 * It is built using the mui table components.
 * */
export const OocvTable = ({ oocvTableData }: OocvTableProps) => {
  const { headline, rows } = getFragmentData(OocvTableFragmentFragmentDoc, oocvTableData);

  return (
    <table className="border-color-grey-light w-full table-fixed border-collapse border-2">
      <thead>
        <tr>
          <th colSpan={2} className="bg-color-grey-light px-1.5 py-1 text-left font-light">
            {headline}
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => (
          /* eslint-disable-next-line react/no-array-index-key */
          <tr key={index}>
            <td className={`${tdStyle} font-bold`}>
              <p>{row.key}</p>
            </td>
            <td className={tdStyle}>
              <div
                className="whitespace-pre-line"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(row.value),
                }}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
